<template>
	<form
		class="form"
		enctype="multipart/form-data"
		method="POST"
		@submit=" onSubmit "
	>
		<slot />

		<div class="actions">
			<Button is-submit>
				{{ name }}
			</Button>
		</div>
	</form>
</template>

<script lang="ts" setup>
const emit = defineEmits ( [ 'submit' ] )

const props = defineProps ( {
	name: {
		type: String,
		default: 'Submit'
	}
} )

const onSubmit = async ( e: Event ) =>
{
	e.preventDefault ()

	const form = e.target as HTMLFormElement

	const formData = new FormData ( form )

	const res = await fetch ( form.action, {
		method: 'POST',
		body: formData
	} )

	emit ( 'submit', res )
}

</script>

<style scoped>
.actions {
	font-size: 1.25em;
	text-align: right;
}
</style>
